<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>链接管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        v-model="query"
        @submit.native.prevent="getList();"
      >
        <el-form-item label="搜索" prop="key">
          <el-input v-model="key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="type" filterable @change="typeClick()">
            <el-option label="请选择" value></el-option>
            <el-option v-for="item in typelist" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button type="success" @click="dialogVisible=true;form={isEnable:true};">新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>链接列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%;"
        >
          <el-table-column prop="name" label="链接名称"></el-table-column>
          <el-table-column prop="url" label="链接地址">
            <template slot-scope="scope">
              <a :href="scope.row.url" target="_blank">{{scope.row.url}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="typeName" label="链接类型"></el-table-column>
          <el-table-column prop="sort" label="排序地址"></el-table-column>
          <el-table-column prop="summary" label="备注"></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="editClick(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <el-button
                  type="warning"
                  size="mini"
                  icon="el-icon-delete"
                  @click="delClick(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog :title="form.id>0?'编辑链接信息':'添加链接信息'" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item
          label="链接名称"
          prop="name"
          :rules="[
        {required:true,message:'请输入链接名称'}
        ]"
        >
          <el-input v-model="form.name" placeholder="请输入链接名称"></el-input>
        </el-form-item>

        <el-form-item
          label="链接地址"
          prop="url"
          :rules="[{required:true,message:'链接不能为空'},
        {type:'url',message:'请输入正确的链接',trigger:'blur'}]"
        >
          <el-input v-model="form.url" placeholder="请输入链接地址"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="链接类型" prop="type" :rules="[{required:true,message:'请输入链接类型'}]">
              <el-select v-model="form.type" filterable>
                <el-option
                  v-for="item in typelist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="排序地址" prop="sort">
          <el-input v-model="form.sort" placeholder="请输入排序地址"></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="summary">
          <el-input v-model="form.summary"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      type: "",
      typelist: [], //链接类型
      key: "",
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.key = _this.key;
      params.type = _this.type;
      var link = url.getBaseData("getlist_link");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 类型搜索
    typeClick:function(){
      this.getList();
    },
    //获取链接类型
    typeLink: function() {
      var _this = this;
      var link = url.getBaseData("getlinktype");
      $.get(link, {}, data => {
        _this.typelist = data;
      });
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getBaseData("addorupdate_link");
      var info = this.form;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    //删除
    delClick: function(row) {
      var _this = this;
      var link = url.getBaseData("delete_link"); //获取请求地址
      var id = row.id; //获取对象id

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { idStr: id }, res => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },
  mounted() {
    //获取服务器列表
    this.getList();
    //获取链接类型
    this.typeLink();
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
</style>
